import { createPortal } from "react-dom";
import { X } from "lucide-react";
import TermsAndConditions from "@/pages/TermsAndConditions";
import PrivacyPolicy from "@/pages/PrivacyPolicy";

// In-page legal pop-up for the ad funnel. Renders the SAME page components
// used on the main site, so it always reflects the latest terms/policy content.
export default function AdFunnelLegalModal({ which, onClose }) {
  if (!which) return null;
  const title = which === "terms" ? "Terms & Conditions" : "Privacy Policy";
  return createPortal(
    <div onClick={onClose} style={{ position: "fixed", inset: 0, zIndex: 9999, background: "rgba(0,0,0,0.6)", display: "flex", alignItems: "center", justifyContent: "center", padding: "16px" }}>
      <div onClick={e => e.stopPropagation()} style={{ background: "#fff", borderRadius: 16, width: "100%", maxWidth: 560, maxHeight: "88vh", display: "flex", flexDirection: "column", overflow: "hidden", boxShadow: "0 24px 80px rgba(0,0,0,0.3)" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 18px", borderBottom: "1px solid #EEE", flexShrink: 0 }}>
          <h3 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: 16, color: "#1A1A1A", margin: 0 }}>{title}</h3>
          <button onClick={onClose} aria-label="Close" style={{ background: "#F5F5F5", border: "none", borderRadius: "50%", width: 32, height: 32, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <X size={16} color="#666" />
          </button>
        </div>
        <div style={{ overflowY: "auto", padding: "18px", fontFamily: "'Inter', sans-serif" }}>
          {which === "terms" ? <TermsAndConditions /> : <PrivacyPolicy />}
        </div>
      </div>
    </div>,
    document.body
  );
}